var React = require('react');

function ChatSendIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"opacity":"0.3","d":"M5.14882 13.8925C4.96668 13.9334 4.82248 14.0723 4.77485 14.2528L3 20.9785C3 21.7235 3.70131 22.2173 4.3151 21.9045L20.4627 13.6743C21.1529 13.3225 21.1854 12.255 20.5181 11.8531L4.37053 2.12653C3.75332 1.75475 3 2.24681 3 3.02173L4.77703 9.599C4.82365 9.77154 4.95881 9.90607 5.13155 9.95188L11.213 11.5647C11.7187 11.6988 11.7048 12.4213 11.1943 12.5359L5.14882 13.8925Z","fill":"#E8EFFF"}));
}

ChatSendIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ChatSendIcon;

ChatSendIcon.default = ChatSendIcon;
